export const APP_MENU_STATE_HOVER = "hover";
export const APP_MENU_STATE_ICON = "icon";
export const APP_MENU_STATE_PINNED = "pinned";
